"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Element_1 = require("../Element");
exports.Card = (0, styled_components_1.default)(Element_1.Element)(_ => ({
    padding: '24px',
    borderRadius: '4px',
    backgroundColor: '#1D1D1D',
}));
